import * as React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger } from '../../../../web/components-v2/Select';
import { ISelectOption } from '../../../../web/components/DeprecatedSelect';
import { IRepeaterItem, Repeater } from '../../ContactInfo/components/Repeater';
import { Group } from '../../leadView/components/Group';
import { styleSheet } from '../styles';
import { generateTimeOptions } from '../utils';

interface IRange {
	start: ISelectOption<number>;
	end: ISelectOption<number>;
}

interface IProps {
	disabled: boolean;
	onChange: (values: IRange[]) => void;
	values: IRange[];
}

enum TimeRangeKey {
	End = 'end',
	Start = 'start',
}

export const TimeRangeRepeater: React.FC<IProps> = React.memo(function TimeRangeRepeaterBase({
	disabled,
	onChange,
	values,
}) {
	const handleRepeaterChange = (newValues: IRepeaterItem<IRange>[]) => {
		const sorted = newValues
			?.map(i => i.content)
			?.sort((a, b) => {
				if (a.start.dataContext < b.start.dataContext) {
					return -1;
				}
				if (a.start.dataContext > b.start.dataContext) {
					return 1;
				}
				return 0;
			});
		onChange(sorted);
	};
	const options: ISelectOption<number>[] = [...generateTimeOptions()];
	return (
		<Repeater<IRange>
			disabled={disabled}
			initialValues={values}
			onChange={handleRepeaterChange}
			contentToAdd={{
				end: options[17],
				start: options[8],
			}}
		>
			{(item, handleContentChange) => {
				const handleTimeChange = (key: TimeRangeKey) => (option: ISelectOption<number>) => {
					const newTimeRange = { ...item?.content, [key]: option };
					handleContentChange(newTimeRange);
				};
				const content = item?.content;
				const endOptions = [...options]?.filter(i => i.dataContext > content?.start?.dataContext);
				const startOptions = [...options]?.filter(i => i.dataContext < content?.end?.dataContext);
				const resolvedStartOptions = startOptions?.length <= 0 ? options : startOptions;
				const resolvedEndOptions = endOptions?.length <= 0 ? options : endOptions;
				return (
					<Group vCentered={true}>
						<Select
							disabled={disabled}
							value={content?.start?.id}
							onValueChange={id => {
								const option = resolvedStartOptions.find(o => o.id === id);
								if (option) handleTimeChange(TimeRangeKey.Start)(option);
							}}
						>
							<SelectTrigger styles={styleSheet.timeSelectCondensed}>
								<span>{content?.start?.text ?? 'Select...'}</span>
							</SelectTrigger>
							<SelectContent>
								{resolvedStartOptions.map(option => (
									<SelectItem key={option.id} value={option.id}>
										{option.text}
									</SelectItem>
								))}
							</SelectContent>
						</Select>
						<small>to</small>
						<Select
							disabled={disabled}
							value={content?.end?.id}
							onValueChange={id => {
								const option = resolvedEndOptions.find(o => o.id === id);
								if (option) handleTimeChange(TimeRangeKey.End)(option);
							}}
						>
							<SelectTrigger styles={styleSheet.timeSelectCondensed}>
								<span>{content?.end?.text ?? 'Select...'}</span>
							</SelectTrigger>
							<SelectContent>
								{resolvedEndOptions.map(option => (
									<SelectItem key={option.id} value={option.id}>
										{option.text}
									</SelectItem>
								))}
							</SelectContent>
						</Select>
					</Group>
				);
			}}
		</Repeater>
	);
});
